///<amd-module name="typeahead/client/ClientHandlerRegistry" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
import {FormSubmittedMessage} from "typeahead/core/message/FormSubmittedMessage";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {UserExitedMessage} from "typeahead/core/message/UserExitedMessage";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export interface IClientHandler {
    isApplicable(clientId: string): boolean;
    subscribeFormLoadedEvent(): void;
    subscribeFormSubmitEvent(): void;
    getTab(): string;
}

export class ClientHandlerRegistry {

    public static handlePageLoad() {
        let clientId = TypeaheadUtils.getClientId();
        ClientHandlerRegistry.client = ClientHandlerRegistry.getClientHandler(clientId);
        ClientHandlerRegistry.client.subscribeFormLoadedEvent();
        ClientHandlerRegistry.client.subscribeFormSubmitEvent();
    }

    public static getTab(): string {
        return ClientHandlerRegistry.client ? ClientHandlerRegistry.client.getTab() : undefined;
    }

    public static registerClient(client: IClientHandler) {
        if (ClientHandlerRegistry.allClients.indexOf(client) < 0) {
            ClientHandlerRegistry.allClients.push(client);
        }
    }
    public static publishSubmitClickedMessage(rfrrIdPrefix: string, event?: JQueryEventObject): void {
        TypeaheadMessage.publish(new SubmitClickedMessage(rfrrIdPrefix, event));
        TypeaheadMessage.publish(new UserExitedMessage());
    }

    public static publishFormSubmittedMessage(isFormValid: boolean): void {
        TypeaheadMessage.publish(new FormSubmittedMessage(isFormValid, coreContext));
    }
    private static allClients: IClientHandler[] = [];
    private static client: IClientHandler;

    private static getClientHandler(clientId: string): IClientHandler {
        let clientHandler: IClientHandler = undefined;
        if (clientId) {
            for (let i: number = 0; i < ClientHandlerRegistry.allClients.length; i++) {
                if (ClientHandlerRegistry.allClients[i].isApplicable(clientId)) {
                    clientHandler = ClientHandlerRegistry.allClients[i];
                    break;
                }
            }
        }
        return clientHandler;
    }
}
